var validate = require('./dist/validate').default;

module.exports = validate;